import { render } from "./pile.vue?vue&type=template&id=021c0612&scoped=true"
import script from "./pile.vue?vue&type=script&lang=js"
export * from "./pile.vue?vue&type=script&lang=js"

import "./pile.vue?vue&type=style&index=0&id=021c0612&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021c0612"]])

export default __exports__